import { render, staticRenderFns } from "./HeaderUsers.vue?vue&type=template&id=0bc3668c&scoped=true"
import script from "./HeaderUsers.vue?vue&type=script&lang=js"
export * from "./HeaderUsers.vue?vue&type=script&lang=js"
import style0 from "./HeaderUsers.vue?vue&type=style&index=0&id=0bc3668c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3668c",
  null
  
)

export default component.exports